import { render } from "./DarkModeBtn.vue?vue&type=template&id=1e5cdc3e&scoped=true"
import script from "./DarkModeBtn.vue?vue&type=script&lang=js"
export * from "./DarkModeBtn.vue?vue&type=script&lang=js"

import "./DarkModeBtn.vue?vue&type=style&index=0&id=1e5cdc3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5cdc3e"]])

export default __exports__